import { toast } from 'react-toastify';
import { waitDialog } from 'dialogs';
import type { CreateTarget } from 'actions';
import { getConnection, type FetchedConnection } from 'api/connections/endpoints/getConnection';
import EditConnectionModal from '../EditConnectionModal';

export type ShowEditConnectionArgs = { readonly mode: 'create'; readonly createIn?: CreateTarget } | { readonly mode: 'edit'; readonly id: number };

/**
 * Open the connection create / edit modal and resolve when it closes (so the
 * caller can refresh). Standalone async: for edit it always fetches the record
 * by id (boundary-validated), so it works from the Workspace — which never
 * populates the list slice — and never opens the modal on a loosely-cast row.
 */
export const showEditConnection = async (args: ShowEditConnectionArgs): Promise<void> => {
  const createIn = args.mode === 'create' ? args.createIn : undefined;
  let connection: FetchedConnection | null = null;
  if (args.mode === 'edit') {
    connection = await getConnection(args.id);
    if (!connection) {
      toast.error('Connection not found; the list may be out of date. Please refresh.');
      return;
    }
  }
  await waitDialog<void>((ok) => <EditConnectionModal show handleClose={ok} mode={args.mode} connection={connection} createIn={createIn} />);
};
